export default __webpack_public_path__ + "static/media/multi-cloud-icon.46767552.svg";